var messages = {
  okText: 'Ok',
  cancelText: 'Cancel'
};
export default messages;